import { render, staticRenderFns } from "./Remision.vue?vue&type=template&id=3ae58772"
import script from "./Remision.vue?vue&type=script&lang=js"
export * from "./Remision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports